import {
  CustomColors
} from './colors';

export const PopupConfig = {
  InvalidOtp: {
    text: 'Looks like you entered an invalid OTP. Please try again.',
    textColor: CustomColors.Grey10,
    backgroundColor: CustomColors.Yellow3
  },
  OtpResent: {
    text: 'Your One-Time PIN has been resent. Please check your inbox.',
    textColor: CustomColors.White,
    backgroundColor: CustomColors.Blue2
  },
  OtpLocked: {
    text: 'You have entered the incorrect OTP too many times. Your account is currently locked.',
    textColor: CustomColors.Grey10,
    backgroundColor: CustomColors.Yellow3
  },
  OtpResendError: {
    text: 'There was en error with resending your OTP.',
    textColor: CustomColors.Grey10,
    backgroundColor: CustomColors.Yellow3
  },
  OtpLockError: {
    text: 'You have entered the OTP incorrectly three times. For your security, you are temporarily blocked from requesting new OTPs. Please try again in 24 hours.',
    textColor: CustomColors.Grey10,
    backgroundColor: CustomColors.Yellow3
  }
};